var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframe",attrs:{"id":"loginWindow","src":_vm.src},on:{"load":function($event){return _vm.onLoad()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }